<main>
    @if (campaignDetail(); as campaign) {
        <!-- @Reviewer: This is a hacky way to get the content of the campaign. Because of Angular Issue to resolve the interface of the content. -->
        @switch (campaign.__contenttype) {
            @case ('AfterSale') {
                <app-campaign-detail-page-after-sale />
            }
            @case ('SalesCampaignContent') {
                <app-campaign-detail-page-sales-campaign />
            }
        }
    }
</main>
